var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import { getMedicalAccount } from "@irati/medical/services/medical";
import medicalTracking from "@irati-tracking/medical";
import GetStarted from "./GetStarted";
import ActivationCode from "./ActivationCode";
import MyMedical from "./MyMedical";
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCreateMedicalUser = function (user) {
            medicalTracking.detailsSubmitted(user.activationCode);
            _this.setState({ user: user });
        };
        _this.getComponent = function () {
            var user = _this.state.user;
            var isGhostUser = authentication.isUserGhost();
            if (user.activated || isGhostUser) {
                return React.createElement(MyMedical, { user: user });
            }
            if (user.activationCode) {
                return React.createElement(ActivationCode, { user: user });
            }
            return React.createElement(GetStarted, { onCreateMedicalUser: _this.handleCreateMedicalUser });
        };
        _this.state = {
            load: getMedicalAccount(authentication.user()).then(function (user) {
                _this.setState({ user: user });
            }).catch(function (err) {
                if (err.response.status !== 404) {
                    throw err;
                }
            }),
            user: {
                activated: null,
                activationCode: null
            }
        };
        return _this;
    }
    Home.prototype.render = function () {
        var load = this.state.load;
        return (React.createElement(Loading, { load: load }, this.getComponent()));
    };
    return Home;
}(Component));
export default Home;
